import { Camera, ClipboardCheck, Eye, Video } from "lucide-react";
import { useLanguage } from "@/i18n";
import { Reveal, SectionHeader } from "@/components/Reveal";

const IMG =
  "https://images.unsplash.com/photo-1628592102751-ba83b0314276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTI0OTIxMTd8MA&ixlib=rb-4.1.0&q=85";

const ICONS = [Eye, Video, ClipboardCheck, Camera];

export const ServicesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 sm:py-32 bg-obsidian" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader eyebrow={t.services.eyebrow} title={t.services.title} sub={t.services.sub} />

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          <Reveal className="md:col-span-2 md:row-span-2">
            <div className="group relative h-full min-h-[380px] rounded-lg overflow-hidden border border-hairline hover:border-gold/40 transition-colors duration-500">
              <img
                src={IMG}
                alt={t.services.imageCaption}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/30 to-transparent" />
              <div className="absolute bottom-0 p-8 sm:p-10">
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold mb-3">01 — {t.services.eyebrow}</p>
                <p className="font-serif text-2xl sm:text-3xl text-ivory">{t.services.imageCaption}</p>
              </div>
            </div>
          </Reveal>

          {t.services.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={0.1 * (i + 1)}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group h-full bg-midnight border border-hairline rounded-lg p-7 sm:p-8 hover:border-gold/40 hover:bg-surface transition-colors duration-500"
                >
                  <Icon className="w-6 h-6 text-gold mb-5" strokeWidth={1.5} />
                  <h3 className="font-serif text-xl sm:text-2xl font-semibold text-ivory">{card.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{card.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
